module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dia_container"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.editTab),
      callback: function($$v) {
        _vm.editTab = $$v
      },
      expression: "editTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "企业信息",
      "name": "first"
    }
  }, [_c('div', {
    staticClass: "base_info"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("企业信息：")]), _vm._v(" "), _c('div', {
    staticClass: "info_content cl"
  }, [_c('div', {
    staticClass: "info_line l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("企业名称"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v("：")]), _vm._v(" "), _c('div', {
    staticClass: "l inpt"
  }, [_c('el-input', {
    model: {
      value: (_vm.config.tenantname),
      callback: function($$v) {
        _vm.$set(_vm.config, "tenantname", $$v)
      },
      expression: "config.tenantname"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info_line l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("企业id"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v("：")]), _vm._v(" "), _c('div', {
    staticClass: "l inpt"
  }, [_c('el-input', {
    class: {
      genCode: !_vm.edit
    },
    attrs: {
      "disabled": _vm.edit
    },
    model: {
      value: (_vm.config.tenantcode),
      callback: function($$v) {
        _vm.$set(_vm.config, "tenantcode", $$v)
      },
      expression: "config.tenantcode"
    }
  }), _vm._v(" "), (!_vm.edit) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.genCode
    }
  }, [_vm._v("生成ID")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info_line l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("企业简称：")]), _vm._v(" "), _c('div', {
    staticClass: "l inpt"
  }, [_c('el-input', {
    model: {
      value: (_vm.config.tenantshortname),
      callback: function($$v) {
        _vm.$set(_vm.config, "tenantshortname", $$v)
      },
      expression: "config.tenantshortname"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info_line l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("人员规模"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v("：")]), _vm._v(" "), _c('div', {
    staticClass: "l sel"
  }, [_c('el-select', {
    model: {
      value: (_vm.config.personnelscale),
      callback: function($$v) {
        _vm.$set(_vm.config, "personnelscale", $$v)
      },
      expression: "config.personnelscale"
    }
  }, _vm._l((_vm.optionsPersonnelScale), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.dicvalue,
        "value": item.dictionaryid
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info_line l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("实施级别"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v("：")]), _vm._v(" "), _c('div', {
    staticClass: "l sel"
  }, [_c('el-select', {
    model: {
      value: (_vm.config.implementlevel),
      callback: function($$v) {
        _vm.$set(_vm.config, "implementlevel", $$v)
      },
      expression: "config.implementlevel"
    }
  }, [(_vm.implementlevel == '0') ? _c('el-option', {
    attrs: {
      "label": "产品开发",
      "value": 0
    }
  }) : _vm._e(), _vm._v(" "), (_vm.implementlevel != '0') ? _c('el-option', {
    attrs: {
      "label": "标准产品",
      "value": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.implementlevel != '0') ? _c('el-option', {
    attrs: {
      "label": "标准配置",
      "value": 2
    }
  }) : _vm._e(), _vm._v(" "), (_vm.implementlevel != '0') ? _c('el-option', {
    attrs: {
      "label": "实施级配置",
      "value": 3
    }
  }) : _vm._e(), _vm._v(" "), (_vm.implementlevel != '0') ? _c('el-option', {
    attrs: {
      "label": "代码级修改",
      "value": 4
    }
  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info_line l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("资源等级"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v("：")]), _vm._v(" "), _c('div', {
    staticClass: "l sel"
  }, [_c('el-select', {
    model: {
      value: (_vm.config.sourcetype),
      callback: function($$v) {
        _vm.$set(_vm.config, "sourcetype", $$v)
      },
      expression: "config.sourcetype"
    }
  }, _vm._l((_vm.optionsSourceType), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.dicvalue,
        "value": item.dictionaryid
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info_line l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("租户类型"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v("：")]), _vm._v(" "), _c('div', {
    staticClass: "l sel"
  }, [_c('el-select', {
    model: {
      value: (_vm.config.tenanttype),
      callback: function($$v) {
        _vm.$set(_vm.config, "tenanttype", $$v)
      },
      expression: "config.tenanttype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "战略客户",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "核心客户",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "价值客户",
      "value": 3
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info_line l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("所属行业"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v("：")]), _vm._v(" "), _c('div', {
    staticClass: "l sel"
  }, [_c('el-select', {
    model: {
      value: (_vm.config.industry),
      callback: function($$v) {
        _vm.$set(_vm.config, "industry", $$v)
      },
      expression: "config.industry"
    }
  }, _vm._l((_vm.optionsIndustry), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.industryname,
        "value": item.industrycode
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info_line l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("企业联系人"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v("：")]), _vm._v(" "), _c('div', {
    staticClass: "l inpt"
  }, [_c('el-input', {
    model: {
      value: (_vm.config.contact),
      callback: function($$v) {
        _vm.$set(_vm.config, "contact", $$v)
      },
      expression: "config.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info_line l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("联系人手机号"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v("：")]), _vm._v(" "), _c('div', {
    staticClass: "l inpt"
  }, [_c('el-input', {
    model: {
      value: (_vm.config.mobile),
      callback: function($$v) {
        _vm.$set(_vm.config, "mobile", $$v)
      },
      expression: "config.mobile"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info_line l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("联系邮箱"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v("：")]), _vm._v(" "), _c('div', {
    staticClass: "l inpt"
  }, [_c('el-input', {
    model: {
      value: (_vm.config.email),
      callback: function($$v) {
        _vm.$set(_vm.config, "email", $$v)
      },
      expression: "config.email"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info_line l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("公司座机"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v("：")]), _vm._v(" "), _c('div', {
    staticClass: "l inpt"
  }, [_c('el-input', {
    model: {
      value: (_vm.config.telephone),
      callback: function($$v) {
        _vm.$set(_vm.config, "telephone", $$v)
      },
      expression: "config.telephone"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info_line l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("开通用途"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v("：")]), _vm._v(" "), _c('div', {
    staticClass: "l sel"
  }, [_c('el-select', {
    model: {
      value: (_vm.config.tenantapplytype),
      callback: function($$v) {
        _vm.$set(_vm.config, "tenantapplytype", $$v)
      },
      expression: "config.tenantapplytype"
    }
  }, _vm._l((_vm.optionsApplyType), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.dicvalue,
        "value": item.dictionaryid
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info_line l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("有效截止日期"), (_vm.config.tenantapplytype == '1') ? _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]) : _vm._e(), _vm._v("：")]), _vm._v(" "), _c('div', {
    staticClass: "l sel"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "picker-options": _vm.pickerOptions,
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.config.expiredtime),
      callback: function($$v) {
        _vm.$set(_vm.config, "expiredtime", $$v)
      },
      expression: "config.expiredtime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info_line w100p l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("企业地址：")]), _vm._v(" "), _c('div', {
    staticClass: "l inpt"
  }, [_c('el-input', {
    model: {
      value: (_vm.config.address),
      callback: function($$v) {
        _vm.$set(_vm.config, "address", $$v)
      },
      expression: "config.address"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info_line w100p l"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("企业介绍：")]), _vm._v(" "), _c('div', {
    staticClass: "l textarea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.config.tenantdescr),
      callback: function($$v) {
        _vm.$set(_vm.config, "tenantdescr", $$v)
      },
      expression: "config.tenantdescr"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "dia_btn_container"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveCompanyInfo
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "应用模块",
      "disabled": !_vm.edit,
      "name": "second"
    }
  }, [_c('div', {
    staticClass: "cl app_model_container"
  }, [_c('div', {
    staticClass: "l mode_list"
  }, _vm._l((_vm.options.productSeries), function(item) {
    return _c('div', {
      staticClass: "item",
      class: {
        current: item.productseriescode === _vm.curSerie
      },
      on: {
        "click": function($event) {
          _vm.switchSeries(item)
        }
      }
    }, [_vm._v(_vm._s(item.productseriesname)), _c('i', {
      staticClass: "fa fa-angle-right"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "l mode_list"
  }, _vm._l((_vm.options.products), function(item) {
    return _c('div', {
      staticClass: "item",
      class: {
        current: item.productcode === _vm.curProduct
      },
      on: {
        "click": function($event) {
          _vm.switchProducts(item)
        }
      }
    }, [_vm._v(_vm._s(item.productname)), _c('i', {
      staticClass: "fa fa-angle-right"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "l mode_list"
  }, _vm._l((_vm.options.productVersions), function(item) {
    return _c('div', {
      staticClass: "item",
      class: {
        current: item.productversioncode === _vm.curVersion
      },
      on: {
        "click": function($event) {
          _vm.switchVersions(item)
        }
      }
    }, [_vm._v(_vm._s(item.productversionname)), _c('i', {
      staticClass: "fa fa-angle-right"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "l mode_list"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.curPackage),
      callback: function($$v) {
        _vm.curPackage = $$v
      },
      expression: "curPackage"
    }
  }, _vm._l((_vm.options.productPackages), function(item, idx) {
    return _c('el-radio', {
      key: idx,
      attrs: {
        "label": item.productpackagecode
      }
    }, [_vm._v(_vm._s(item.productpackagename))])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dia_btn_container"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveAppModel
    }
  }, [_vm._v("保存")])], 1)])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-16ec9a58", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16ec9a58","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tenants/dialog/Edit.vue
// module id = 204
// module chunks = 0